module.exports = __webpack_public_path__ + "static/media/Component 1.e806b1e6.svg";